import React from 'react';

const LEVELS = [
  {
    id: 'level1',
    label: 'Level 1',
    title: 'Customer Care / Helpdesk',
    timeline: 'Within 7 working days',
    scope: 'General queries, service-related complaints',
    email: 'info@ascendcap.in',
    phone: '+91-8741092723',
    primaryAction: { type: 'tel', value: '+918741092723', label: 'Call Customer Care' },
  },
  {
    id: 'level2',
    label: 'Level 2',
    title: 'Functional Escalation Officer (Sales / Collections)',
    timeline: 'Within 7 working days',
    scope: 'Complaints not resolved at Level 1',
    email: 'escalation@ascendcap.in',
    primaryAction: { type: 'mailto', value: 'escalation@ascendcap.in', label: 'Email Escalation' },
  },
  {
    id: 'level3',
    label: 'Level 3',
    title: 'Grievance Redressal Officer (GRO)',
    timeline: 'Within 30 days',
    scope: 'Complaints not resolved at Level 2',
    name: 'Mr. Deepak Kumawat',
    designation: 'Customer Grievance & Redressal Officer',
    email: 'accounts@ascendcap.in',
    primaryAction: { type: 'mailto', value: 'accounts@ascendcap.in', label: 'Email GRO' },
  },
  {
    id: 'rbi',
    label: 'RBI CMS',
    title: 'RBI Ombudsman – Complaint Management System (CMS)',
    timeline: 'If not resolved within 30 days / not satisfied',
    scope:
      'If a complaint is not resolved within 30 days, or if the customer is not satisfied with the resolution provided, the customer may approach the RBI through CMS.',
    website: 'https://cms.rbi.org.in',
    primaryAction: { type: 'link', value: 'https://cms.rbi.org.in', label: 'Visit RBI CMS' },
  },
];

class CustomerGrievance extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeId: LEVELS[0].id };
  }

  scrollToEscalationMatrix = () => {
    const el = document.getElementById('grievance-escalation-matrix');
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  setActive = (activeId) => {
    this.setState({ activeId });
  };

  openPrimaryAction = (level) => {
    if (!level || !level.primaryAction) return;
    const { type, value } = level.primaryAction;

    if (type === 'mailto') window.location.href = `mailto:${value}`;
    if (type === 'tel') window.location.href = `tel:${value}`;
    // if (type === 'link') window.open(value, '_blank', 'noopener,noreferrer');
  };

  renderLevelDetailRow(label, value) {
    if (!value) return null;
    return (
      <div className="grievance-kv">
        <div className="grievance-kv__k">{label}</div>
        <div className="grievance-kv__v">{value}</div>
      </div>
    );
  }

  render() {
    const activeLevel = LEVELS.find(l => l.id === this.state.activeId) || LEVELS[0];

    return (
      <div className="about-us grievance-page">
        <div className="container grievance-container privacy">
          <div className="grievance-hero">
            <h1 className="grievance-title">Customer Grievance</h1>
            <p className="grievance-subtitle">Customer Grievance Redressal &amp; Escalation Matrix</p>

            <div className="grievance-quick-actions">
              <button
                type="button"
                className="grievance-cta"
                onClick={() => (window.location.href = 'mailto:info@ascendcap.in')}
              >
                <span className="grievance-cta__label">Email</span>
                <span className="grievance-cta__value">info@ascendcap.in</span>
              </button>
              <button
                type="button"
                className="grievance-cta"
                onClick={() => (window.location.href = 'tel:+918741092723')}
              >
                <span className="grievance-cta__label">Call</span>
                <span className="grievance-cta__value">+91-8741092723</span>
              </button>
              <button
                type="button"
                className="grievance-cta grievance-cta--outline"
                onClick={() => {
                  this.setActive('level2');
                  this.scrollToEscalationMatrix();
                }}
              >
                <span className="grievance-cta__label">Not Resolved?</span>
                <span className="grievance-cta__value">Escalate</span>
              </button>
            </div>
          </div>

          <div className="grievance-doc">
            <h3>1. Objective</h3>
            <div className="about-us-content">
              <p>
                Ascend Capital is committed to providing prompt, fair, and transparent resolution of customer grievances
                in compliance with applicable Reserve Bank of India (RBI) guidelines. This page outlines the grievance
                redressal mechanism, escalation levels, and timelines for resolution.
              </p>
            </div>

            <h3>2. No Physical Branch Disclosure</h3>
            <div className="about-us-content">
              <p>
                Ascend Capital operates across multiple cities through centralized and field-based teams and does not
                maintain physical branch offices. All customer grievances are addressed through a structured functional
                escalation mechanism as detailed below.
              </p>
            </div>

            <h3>3. Customer Grievance Redressal Mechanism</h3>
            <div className="about-us-content">
              <p>
                Customers may raise their grievances through the following escalation levels. Each level has defined
                timelines to ensure timely resolution.
              </p>
            </div>

            <h3 id="grievance-escalation-matrix">4. Escalation Matrix &amp; Resolution Timelines</h3>
            <div className="grievance-flow-wrap">
              <div className="grievance-flow" role="tablist" aria-label="Escalation levels">
                {LEVELS.map((level, idx) => {
                  const isActive = this.state.activeId === level.id;
                  return (
                    <button
                      key={level.id}
                      type="button"
                      role="tab"
                      aria-selected={isActive}
                      className={`grievance-node ${isActive ? 'is-active' : ''}`}
                      onClick={() => this.setActive(level.id)}
                    >
                      <div className="grievance-node__top">
                        <span className="grievance-node__badge">{idx + 1}</span>
                        <span className="grievance-node__label">{level.label}</span>
                      </div>
                      <div className="grievance-node__title">{level.title}</div>
                      <div className="grievance-node__meta">{level.timeline}</div>
                    </button>
                  );
                })}
              </div>

              <div className="grievance-details" id="grievance-level-details" role="tabpanel">
                <div className="grievance-details__head">
                  <div>
                    <div className="grievance-details__title">{activeLevel.title}</div>
                    <div className="grievance-details__subtitle">{activeLevel.timeline}</div>
                  </div>
                  {activeLevel.id !== 'rbi' && activeLevel.primaryAction && (
                    <button
                      type="button"
                      className="grievance-primary"
                      onClick={() => this.openPrimaryAction(activeLevel)}
                    >
                      {activeLevel.primaryAction.label}
                    </button>
                  )}
                </div>

                <div className="grievance-details__body">
                  {this.renderLevelDetailRow('Scope', activeLevel.scope)}
                  {this.renderLevelDetailRow('Name', activeLevel.name)}
                  {this.renderLevelDetailRow('Designation', activeLevel.designation)}
                  {this.renderLevelDetailRow('Email', activeLevel.email)}
                  {this.renderLevelDetailRow('Mobile', activeLevel.phone)}
                  {activeLevel.website && (
                    <div className="grievance-kv">
                      <div className="grievance-kv__k">Website</div>
                      <div className="grievance-kv__v">
                        {activeLevel.website}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <h3>5. Grievance Redressal Flow</h3>
            <div className="about-us-content">
              <div className="grievance-flowlist">
                <div className="grievance-flowlist__item">Customer Grievance</div>
                <div className="grievance-flowlist__arrow">↓</div>
                <div className="grievance-flowlist__item">Customer Care / Helpdesk (7 working days)</div>
                <div className="grievance-flowlist__arrow">↓</div>
                <div className="grievance-flowlist__item">Functional Escalation Officer (7 working days)</div>
                <div className="grievance-flowlist__arrow">↓</div>
                <div className="grievance-flowlist__item">Grievance Redressal Officer – GRO (30 days)</div>
                <div className="grievance-flowlist__arrow">↓</div>
                <div className="grievance-flowlist__item">RBI Ombudsman – Complaint Management System (CMS)</div>
              </div>
            </div>

            <h3>6. RBI Ombudsman – Complaint Management System (CMS)</h3>
            <div className="about-us-content">
              <p>
                If a complaint is not resolved within 30 days, or if the customer is not satisfied with the resolution
                provided, the customer may approach the Reserve Bank of India through the Complaint Management System
                (CMS):
              </p>
              <p className="grievance-link">
                Website:{' '}
                <span className="grievance-link__static" aria-label="RBI CMS website">
                  https://cms.rbi.org.in
                </span>
              </p>
            </div>

            <h3>7. Commitment</h3>
            <div className="about-us-content">
              <p>
                Ascend Capital endeavours to resolve all customer complaints within the stipulated timelines in a fair,
                transparent, and customer-centric manner, in line with RBI guidelines and best practices.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomerGrievance;



// WEBPACK FOOTER //
// ./src/components/CustomerGrievance.js